import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const ANIMATION_MS = 320;

// Several panels can overlap while one slides out and the next slides in
let openPanelsCount = 0;
const lockBodyScroll = () => {
    openPanelsCount += 1;
    document.body.style.overflow = 'hidden';
};
const unlockBodyScroll = () => {
    openPanelsCount = Math.max(0, openPanelsCount - 1);
    if (!openPanelsCount) document.body.style.overflow = '';
};

/**
 * Left slide-in panel with the Job Planner panel look (header, scrollable body, footer).
 * Content is mounted only while the panel is open or animating out.
 */
const SlidePanel = ({
    open,
    onClose,
    title,
    subtitle,
    headerStart,
    footer,
    className = '',
    children,
}) => {
    const [isRendered, setIsRendered] = useState(false);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (!open) return undefined;
        setIsRendered(true);
        lockBodyScroll();
        const frame = requestAnimationFrame(() => setIsActive(true));
        return () => {
            cancelAnimationFrame(frame);
            unlockBodyScroll();
            setIsActive(false);
        };
    }, [open]);

    useEffect(() => {
        if (open || !isRendered) return undefined;
        const timer = window.setTimeout(() => setIsRendered(false), ANIMATION_MS);
        return () => window.clearTimeout(timer);
    }, [open, isRendered]);

    if (!isRendered) return null;

    return ReactDOM.createPortal(
        <>
            <div
                className={`jobPlannerSlideBackdrop ${isActive ? 'open' : ''}`}
                onClick={onClose}
                aria-hidden="true"
            />
            <div
                className={`jobPlannerSlidePanel appSlidePanel ${className} ${isActive ? 'open' : ''}`}
                role="dialog"
                aria-modal="true"
                aria-label={typeof title === 'string' ? title : undefined}
            >
                <div className="jobPlannerSlidePanelHeader">
                    <div className="jobPlannerSlidePanelHeaderMain">
                        {headerStart}
                        <div className="jobPlannerSlidePanelHeaderText">
                            <h2 className="jobPlannerSlidePanelTitle">{title}</h2>
                            {subtitle ? <p className="jobPlannerSlidePanelSubtitle">{subtitle}</p> : null}
                        </div>
                    </div>
                    <div className="jobPlannerSlidePanelHeaderActions">
                        <IconButton
                            onClick={onClose}
                            aria-label="Close"
                            className="jobPlannerSlidePanelClose"
                            size="small"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>
                </div>
                <div className="jobPlannerSlidePanelContent appSlidePanelBody">
                    {children}
                </div>
                {footer ? <div className="appSlidePanelFooter">{footer}</div> : null}
            </div>
        </>,
        document.body,
    );
};

export default SlidePanel;
